export const USER = "USER";
export const LOGIN = "LOGIN";
export const PLACE_DETAILS = "PLACE_DETAILS";
export const COMMERCIAL_DETAILS = "COMMERCIAL_DETAILS";
export const ALL_PLACES_DATA = "ALL_PLACES_DATA";
export const ALL_DEALS_DATA = "ALL_DEALS_DATA";
export const ALL_EVENTS_DATA = "ALL_EVENTS_DATA";
export const ALL_COMMERCIAL_DATA = "ALL_COMMERCIAL_DATA";
export const ALL_USER_COMMERCIAL_DATA = "ALL_USER_COMMERCIAL_DATA";
export const ALL_POPULAR_COMMERCIAL = "ALL_POPULAR_COMMERCIAL";
export const ALL_NEAR_COMMERCIAL = "ALL_NEAR_COMMERCIAL";
export const LANGUAGE = "LANGUAGE";
export const PLACE_STATES = "PLACE_STATES";
export const SAVED_ITEMS="SAVED-ITEMS";